import React, { useState, useRef, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { LuMessageSquareMore, LuListMusic, LuFlame } from 'react-icons/lu';
import { useWebLocale } from '../../contexts/WebLocaleContext';

import { timelineReason, timelineReasonLabel } from './timelinePresentation';
export function timelineAlbumPath(album) {
  return album.slug
    ? `/reviews/${encodeURIComponent(album.slug)}`
    : `/reviews/${encodeURIComponent(String(album.albumSource || 'APPLE_MUSIC').toLowerCase())}/${encodeURIComponent(album.sourceId || album.id)}`;
}
export default function TimelineCard({ item, reason, rediscovered = false }) {
  const { locale } = useWebLocale();
  const album = item.album,
    why = reason || timelineReason(item);
  const [failed, setFailed] = useState(null);
  const Icon =
    why === 'reviews' ? LuMessageSquareMore : why === 'playlists' ? LuListMusic : LuFlame;
  const artist =
    album.artist?.name ||
    (locale === 'ko' ? '아티스트 정보 없음' : 'Artist information unavailable');
  return (
    <Link className="pp-timeline-card" data-timeline-album={album.id} to={timelineAlbumPath(album)}>
      <div className="pp-timeline-cover">
        {album.imageUrl && failed !== album.imageUrl ? (
          <img
            src={album.imageUrl}
            alt=""
            loading="lazy"
            onError={() => setFailed(album.imageUrl)}
          />
        ) : (
          <span>postpop.</span>
        )}
      </div>
      <div className="pp-timeline-copy">
        <TimelineTitle title={album.title} explicit={album.contentRating === 'EXPLICIT'} />
        <span className="pp-timeline-artist" title={artist}>
          {artist}
        </span>
        {rediscovered ? (
          <span className="pp-timeline-reason">
            <Icon aria-hidden="true" size={15} />
            <span>{timelineReasonLabel(item, why, locale)}</span>
          </span>
        ) : (
          <span className="pp-timeline-rating">
            <span aria-hidden="true">★</span>
            {Number(album.averageRating ?? 0).toFixed(1)}
          </span>
        )}
      </div>
    </Link>
  );
}

// iOS60 hides the E badge when the complete one-line title cannot fit.
function TimelineTitle({ title, explicit }) {
  const row = useRef(null),
    natural = useRef(null);
  const [fits, setFits] = useState(false);
  useLayoutEffect(() => {
    if (!explicit) return;
    let alive = true;
    const measure = () => {
      if (alive && row.current && natural.current) {
        const size = parseFloat(getComputedStyle(row.current).fontSize);
        setFits(natural.current.offsetWidth + (size * 10) / 14 + 4 <= row.current.clientWidth);
      }
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(row.current);
    observer?.observe(natural.current);
    document.fonts?.ready.then(measure);
    return () => {
      alive = false;
      observer?.disconnect();
    };
  }, [title, explicit]);
  return (
    <strong ref={row} className="pp-timeline-title">
      <span>{title}</span>
      {explicit && (
        <span
          className="pp-timeline-title-natural"
          ref={natural}
          aria-hidden="true"
          data-title={title}
        />
      )}
      {explicit && fits && <small aria-label="Explicit">E</small>}
    </strong>
  );
}
